import { clamp } from './clamp';
var invlerp = function (a, b, value) {
    return clamp((value - a) / (b - a));
};
export { invlerp };
